"use client";

import { BarChart3 } from "lucide-react";

import { CcAdPerformanceDemo } from "./CcAdPerformanceDemo";
import { GrowthFeatureCard } from "./GrowthFeatureCard";
import {
  DEFAULT_GROWTH_FEATURE_AD_PERFORMANCE_COPY,
  type GrowthFeatureAdPerformanceCardCopy,
} from "./growth-feature-ad-performance-copy";

type GrowthFeatureAdPerformanceProps = {
  copy?: GrowthFeatureAdPerformanceCardCopy;
};

export function GrowthFeatureAdPerformance({
  copy = DEFAULT_GROWTH_FEATURE_AD_PERFORMANCE_COPY,
}: GrowthFeatureAdPerformanceProps = {}) {
  return (
    <GrowthFeatureCard
      className="cc-growth-features__card--ad-performance"
      title={copy.title}
      badge={copy.badge}
      icon={BarChart3}
      description={copy.description}
    >
      <CcAdPerformanceDemo copy={copy.demo} />
    </GrowthFeatureCard>
  );
}
